module.exports = __webpack_public_path__ + "static/oficina_privada-min-d50b088f02d515e5220cdca20873b4b3.jpg";